import { createGlobalStyle } from 'styled-components'
import { normalize } from 'styled-normalize'
import './fonts.css'

export const GlobalStyle = createGlobalStyle`
  ${normalize};

  html {
    box-sizing: border-box;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  :root {
    font-size: 16px;
  }

  body {
    font-family: 'ABC Ginto Normal', sans-serif;
  }

  h2, h3, h4 {
    margin: 0;
  }

  p {
    margin: 0;
  }

  figure {
    margin: 0
  }

  ul, ol {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  a {
    color: inherit;
    text-decoration: none;
  }
`
